

export const API_CONFIG = {
  API_URL: process.env.VUE_APP_API_URL,
  CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
  CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
}

